module.exports = __webpack_public_path__ + "static/media/black_wordmark.b9b588fa.png";